export default __webpack_public_path__ + "static/cool-earth-d7136841c67eb7f981650f81acf99ef3.jpg";